<template>
  <div
    @mouseenter="mouseEnter = openOrCloseDropDown()"
    @mouseleave="false"

    :class="[{ 'mouse-enter': mouseEnter, 'mouse-leave': !mouseEnter }]"
    >
    <dropdown-menu
      id="drop-notifications"
      v-model="mouseEnter"
      transition="translate-fade-down"
    >
      <md-button
        data-v-step="1"
        :md-ripple="false"
        md-elevation="0"
        class="md-icon-button dropdown-toggle notifications-button"
      >
        <md-icon v-if="totalNotifications > 0">notifications_active</md-icon>
        <md-icon v-else>notifications</md-icon>
      </md-button>

      <div
        class="notifications-number outside-number"
        v-if="!wasPopupHovered && totalNotifications > 0"
      >
        {{ totalNotifications }}
      </div>
      <md-content
        slot="dropdown"
        class="md-scrollbar my-drop"
        @click.native="close"
      >
        <SRequestsDropdown
          ref="requestsDropdown"
          :numberOfNotifications="numberOfNotifications"
          :notifications="notifications"
          :notificationsToShow="notificationToShow"
        />
      </md-content>
    </dropdown-menu>
  </div>
</template>

<script>
import DropdownMenu from "@innologica/vue-dropdown-menu";
import SRequestsDropdown from "@/material-components/molecules/SRequestsDropdown.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import itemType from "@/enum/item-type";
import itemStatus from "@/enum/item-status";
import Global from "@/constants/Global";

export default {
  name: "SHeaderNotifications",
  mixins: [UserHelperVue, ChatHelperVue, ItemHelperVue],
  components: {
    DropdownMenu,
    SRequestsDropdown,
  },
  data() {
    return {
      show: false,
      mouseEnter: false,
      wasPopupHovered: false,
    };
  },
  methods: {
    close() {
      this.$emit("changeKey");
    },
    // setNotifications() {
    //   this.wasPopupHovered = false;
    //   this.$refs.requestsDropdown.setNotifications();
    // },
    openOrCloseDropDown() {
      return !Global.checkDevice();
    },
    mountNotif(notif, key1, key2, key3, key4) {
      if (notif.item.posterId === this.loggedUser.id) { 
        if (
          notif.item.type === itemType[key1] ||
          notif.item.type === itemType[key2]
        ) {
          return true
        }
      } else {
        if (
          notif.item.type === itemType[key3] ||
          notif.item.type === itemType[key4]
        ) {
          return true
        }
      }
      return false
    },
    validateArray(arr) {
      if (arr && Array.isArray(arr)) {
        return arr
      }
      return []
    }
  },
  computed: {
    notifications() {
      const userNotifications = this.validateArray(this.activityNotifications.filter((notification)=> notification.seen === 0 ));
      return userNotifications.filter((notif) => {
        const today = new Date();
        let d10 = new Date(notif.changeSituationAt);
        let d20 = new Date(notif.changeSituationAt);
        switch (notif.notification) {
          case "new-request":
          case "accepted":
          case "rejected":
            if (!notif.seen) return notif;
            break;
          case "pending":
            d10.setDate(d10.getDate() + 10);
            d20.setDate(d20.getDate() + 20);
            if (
              !notif.sentSeen &&
              today >= d10 &&
              notif.item.status === itemStatus.WAITING
            ) {
              if (this.mountNotif(notif, 'GIVE', 'LEND', 'RECEIVE', 'BORROW')) return true
            }
            if (
              !notif.receivedSeen &&
              today >= d20 &&
              (notif.item.status === itemStatus.SENT ||
                notif.item.status === itemStatus.WAITING)
            ) {
              if (this.mountNotif(notif, 'RECEIVE', 'BORROW', 'GIVE', 'LEND')) return true
            }
            break;
        }
      });
    },
    notificationToShow() {
      let notifs = this.notifications;
      return notifs.slice(0,4)
    },
    totalNotifications() {
      if (this.wasPopupHovered) return 0;
      return this.numberOfNotifications;
    },
    numberOfNotifications() {
      return this.activityNotifications.filter((notification)=> notification.seen === 0 ).length;
    },
  },
};
</script>

<style lang="scss" scoped>
.md-button {
  background-color: $primary;
}
.md-icon-button {
  margin: 0;
}
.notifications-button {
  height: 42px;
  width: 42px;
}

@media screen and (min-width: 480px) {
  .notifications-button {
    width: 46px;
    height: 46px;
  }
}
@media screen and (min-width: 720px) {
  .notifications-button {
    width: 50px;
    height: 50px;
  }
}

</style>

<style lang="scss" scoped>
.md-button {
  border: 1px solid #e0e0e0;
  border-radius: 5px !important;
}
.md-icon {
  color: $white !important;
}
</style>

<style lang="scss" scoped>
.dropdown-item {
  margin-top: 0.4rem;
  cursor: pointer;
}
.outside-number {
  position: absolute;
  top: 68%;
  right: 0%;
  z-index: 1;
}
</style>

<style lang="scss" scoped>
.my-drop::before {
  position: absolute;
  content: "";
  top: -1px;
  left: 243px;
  transform: translateY(-100%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid $primary;
}
</style>

<!-- Header drop menu style -->
<style lang="scss">
#drop-notifications .show {
  margin-left: -165px;
  width: 280px !important;
  margin-top: 0.95em;
  border: 1px solid $primary;
  left: -65px;
}
#drop-notifications a {
  color: $black !important;
}
#drop-notifications span {
  margin-left: 0.5rem;
  text-align: center;
  font-size: 14px;
  letter-spacing: 1.25px;
}

#drop-notifications a:active {
  background-color: $primary;
}
#drop-notifications .dropdown-item:active {
  background-color: $primary;
}
</style>

<style lang="scss" scoped>
.md-content {
  width: 275px;
  max-height: 400px;
}
</style>

<style lang="scss">
.dropdown-item {
  cursor: pointer;
}
.message-content,
.action-content {
  display: flex;
  flex-direction: column;
}
.container-message,
.container-request-item {
  display: flex;
  margin-top: 0.2rem;
  flex-wrap: nowrap;
}
.no-message {
  display: block;
  padding: 20px;
  margin-left: 0 !important;
}
#activity-link,
#message-link {
  color: rgba(0, 0, 0, 0.4) !important;
}
#activity-link:hover,
#message-link:hover {
  color: $primary !important;
}
.notifications-number {
  background-color: $danger;
  color: $white;
  width: 20px;
  border-radius: 10px;
  text-align: center;
  margin-left: 0.3rem;
}
</style>
